export interface MultiProjectGq {
  id: number;
  childProjectId: number;
  alias?: string;
}

export const MultiProjectGqProps = `
  id
  childProjectId
  alias
`;
